import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  getCurrentBookingSlots,
  updateBookingSlot,
} from "../../State/BookingSlot/Action";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";

const BookingSlot = () => {
  const dispatch = useDispatch();
  const bookingSlot = useSelector((store) => store.bookingSlot);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [slots, setSlots] = useState([]);

  useEffect(() => {
    dispatch(getCurrentBookingSlots());
  }, [dispatch]);

  useEffect(() => {
    if (bookingSlot?.slots) {
      setSlots(bookingSlot.slots);
    }
  }, [bookingSlot.slots]);

  useEffect(() => {
    if (bookingSlot?.slotUpdated?.success) {
      setDialogMessage(bookingSlot?.slotUpdated?.message);
      setDialogOpen(true);
      dispatch(getCurrentBookingSlots()); // Refresh slots after update
    }
  }, [bookingSlot.slotUpdated, dispatch]);

  // Convert minutes into HH:MM AM/PM format
  const formatTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return new Date(0, 0, 0, hours, minutes).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Handle checkbox click and update slot status
  const handleCheckboxChange = (slot) => {
    const updatedData = { ...slot, booked: !slot.booked };
    console.log("Sending to API:", updatedData);

    dispatch(updateBookingSlot(updatedData)).then(() => {
      // Do NOT re-fetch slots, keep the current order
      console.log("Slot updated successfully.");
    });
  };

  // Close dialog
  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Booking Slot</h1>
      {slots.length > 0 ? (
        slots.map((slot) => (
          <div
            key={slot.id || `${slot.date}-${slot.time}`}
            className="border p-2 mb-2 flex items-center justify-between"
          >
            <div>
              <h2 className="text-lg font-semibold">{formatTime(slot.time)}</h2>
              <p className="text-gray-600">
                {moment(slot.date).format("MMMM Do, YYYY")}
              </p>
            </div>
            <label className="flex items-center">
              <input
                type="checkbox"
                checked={slot.booked}
                onChange={() => handleCheckboxChange(slot)}
                className="mr-2"
              />
              <span className="text-sm">
                {slot.booked ? "Booked" : "Available"}
              </span>
            </label>
          </div>
        ))
      ) : (
        <p className="text-gray-500">No slots available</p>
      )}

      {/* Success or Failure Dialog */}
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>Update Status</DialogTitle>
        <DialogContent>
          <p>{dialogMessage}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BookingSlot;
